// src/components/practice/tasks/writing/layouts/OsdC1EmailLayout.jsx
import React from 'react';
import { parseOsdC1EmailWithNotes } from '../parsers/osdC1EmailParser.js';

const OsdC1EmailLayout = ({ inputContent, scenario }) => {
    const parsed = parseOsdC1EmailWithNotes(inputContent);

    if (!parsed) return null;

    return (
        <div className="my-8">
            {/* Situation text */}
            <div className="mb-6">
                <p className="text-gray-800 leading-relaxed">
                    <strong>Situation:</strong> {scenario.split('Formulieren Sie nun')[0].trim()}
                </p>
            </div>

            {/* Email box with shadow and rounded corners */}
            <div className="border-2 border-gray-400 rounded-2xl bg-white shadow-xl overflow-hidden">
                {/* Email header section - gray background */}
                <div className="bg-gray-100 border-b border-gray-400 px-6 py-4 text-sm">
                    <div className="grid grid-cols-[80px_1fr] gap-2">
                        <span className="font-semibold">Von:</span>
                        <span>{parsed.from || '...'}</span>

                        <span className="font-semibold">An:</span>
                        <span>{parsed.to || '.....................'}</span>

                        <span className="font-semibold">Betreff:</span>
                        <span>{parsed.subject || '...'}</span>

                        {parsed.date && (
                            <>
                                <span className="font-semibold">Datum:</span>
                                <span>{parsed.date}</span>
                            </>
                        )}
                    </div>
                </div>

                {/* Email body with notes */}
                <div className="p-6">
                    {/* Salutation */}
                    {parsed.salutation && (
                        <p className="mb-4 text-gray-800">{parsed.salutation}</p>
                    )}

                    {/* Paragraphs with side notes */}
                    <div className="space-y-4">
                        {parsed.paragraphs.map((para, idx) => (
                            <div key={idx} className="flex gap-4">
                                {/* Paragraph text */}
                                <div className="flex-1 text-gray-800 leading-relaxed text-justify">
                                    {para.text}
                                </div>

                                {/* Note on the right */}
                                <div className="w-48 flex-shrink-0">
                                    {para.note && (
                                        <div className="text-sm italic text-gray-600">
                                            → {para.note}
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Closing */}
                    {parsed.closing.length > 0 && (
                        <div className="mt-6 text-gray-800">
                            {parsed.closing.map((line, idx) => (
                                <p key={idx}>{line}</p>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            {/* Instruction text below email */}
            <div className="mt-6 text-gray-800 leading-relaxed">
                {scenario && scenario.split('.').filter(line =>
                    line.includes('Schreiben Sie nun') ||
                    line.includes('Formulieren Sie') ||
                    line.includes('Berücksichtigen Sie')
                ).map(line => line.trim() + '.').join(' ')}
            </div>
        </div>
    );
};

export default OsdC1EmailLayout;